import BaseComponent from "@js/components/base_component.jsx";

class EuiRoutesIndexTable extends BaseComponent {

  render() {
    return ( this.props.table && this.props.table.length > 0 ) ? (
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="column-name">{ t("headings.name") }</th>
            <th className="column-name text-right" style={{width: "200px"}}>{ t("headings.recommended_max_daily_volume") }</th>
            <th className="column-name text-right" style={{width: "200px"}}>{ t("headings.recommended_max_delivery_rate_per_hour") }</th>
            <th className="column-actions" style={{width: "200px"}}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{this._renderRows()}</tbody>
      </table>
    ) : (
      <EmptyTableNotification
        type={I18n.t("labels.routes")}
        offerNew={true}
      />
    );
  }

  _renderRows() {
    return this.props.table.map((route, i) => {
      return (
        <tr key={ i }>
          <td>{ route.name }</td>
          <td className="text-right">{ route.recommended_max_daily_volume && route.recommended_max_daily_volume.toLocaleString() }</td>
          <td className="text-right">{ route.recommended_max_delivery_rate_per_hour && route.recommended_max_delivery_rate_per_hour.toLocaleString() }</td>
          <td className="text-right index-buttons">
            <ButtonEdit
              href={ Routes.edit_eui_route_path(route.id, { return_to: window.location.href }) }
              size="small"
            />
            <ButtonView
              href={ Routes.eui_route_path(route.id) }
              size="small"
            />
          </td>
        </tr>
      );
    });
  }

}

export default EuiRoutesIndexTable;
